<template>
  <span>
    <span @click="changeSelectedOption(option.id)"
          class="clear-both">
      <!-- 单选框 -->
      <template v-if="isType('select')">
        <i :class="[selectedOptionId.includes(option.id)?'sj-icon-round-check':'sj-icon-round']">
          <span>OPT{{index+1}}</span>
        </i>
      </template>

      <!-- 多选框 -->
      <template v-if="isType(['multiselect', 'imageMultiselect'])">
        <i :class="[selectedOptionId.includes(option.id)?'sj-icon-square-check':'sj-icon-square']">
          <span>OPT{{index+1}}</span>
        </i>
      </template>

      <!-- 多选图 -->
      <template v-if="isType('imageMultiselect')">
        <img v-if="option.images[0]"
             :src="option.images[0].src|ossThumbnail(40, 'f9fafc')"
             :alt="option.images[0].src"
             @click.stop="onViewImage(0, option.images)">
      </template>

      <!-- 选项标题 -->
      <span class="option-title">{{option.title}}</span>
      <slot name="append"></slot>

      <!-- 收展按钮 -->
      <el-button
        v-if="isType(['select', 'imageMultiselect'])"
        @click.stop="show=!show"
        type="text"
        icon="sj-icon-circle-down"
        style="padding: 0;"
        :class="['option-collapse', 'pull-right', show ? 'open' : 'close']"></el-button>
    </span>
    <!-- 单选的示例信息 -->
    <el-collapse-transition v-if="isType(['select', 'imageMultiselect'])">
      <div v-show="show"
           class="question-detail">
        <el-row :gutter="20"
                v-if="isType('imageMultiselect')"
                style="width: 100%;">
          <el-col>
            <div class="question-detail-img"
                 v-perfect-scrollbar.relative="{wheelPropagation:true}">
              <ul>
                <li
                  v-for="({src}, index) in option.images"
                  :key="src"
                  @click="onViewImage(index, option.images)">
                  <img :src="src|ossThumbnail(75, 'f9fafc')"
                       alt="">
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20"
                v-if="isType('select')"
                style="width: 100%;">
          <!-- 示例文本 -->
          <el-col :xl="span.xl"
                  :md="span.md"
                  :xs="span.xs">
            <div class="question-detail-text"
                 v-perfect-scrollbar.relative="{wheelPropagation:true}">
              <span>{{option.exampleText | getText}}</span>
            </div>
          </el-col>
          <!-- 示例图片 -->
          <el-col :xl="span.xl"
                  :md="span.md"
                  :xs="span.xs">
            <div class="question-detail-img"
                 v-perfect-scrollbar.relative="{wheelPropagation:true}">
              <ul>
                <li
                  v-for="({src}, index) in option.exampleImages"
                  :key="src"
                  @click="onViewImage(index, option.exampleImages)">
                  <img :src="src|ossThumbnail(75, 'f9fafc')"
                       alt="">
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-collapse-transition>
  </span>
</template>

<script>
import QuestionReview from '../../question-review.js'
import AnswerFileFullScreen from '../../components/AnswerFileFullScreen'

export default {
  components: {},
  mixins: [],
  inject: ['page'],
  props: {
    question: Object,
    questionIndex: Number,
    index: Number,
    option: Object,
    value: Array,
    disabled: Boolean,
    type: String,
  },
  data () {
    return {
      show: false,
      span: {
        xl: 6,
        md: 12,
        xs: 24,
      },
    }
  },
  computed: {
    selectedOptionId () {
      return this.value
    },
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {
  },
  methods: {
    ...Vuex.mapActions([]),
    isType (type) {
      if (type instanceof Array) {
        return type.includes(this.type)
      }
      return this.type === type
    },
    changeSelectedOption (optionId) {
      if (this.disabled) {
        return
      }
      if (QuestionReview().changeSelectedOption(this.question.id, optionId)) {
        // 修改值事件
        this.$emit('change', optionId)
        this.$message.warning('已更改答案选项')
        // sjf 调整
        if (this.page.orderDetail.type === '23' && this.question.title === '【拍照】现场桌面用酒，体现品项、数量、毫升数【必选】') {
          if (this.page.sjfOrderDetail.yxh__productName !== this.option.title) {
            this.$alert('当前选择用酒与提报用酒的酒品不一致', '提示')
          }
        }
      } else {
        this.$message.error('至少选中一个选项')
      }
    },
    onViewImage (index, files) {
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: files,
        viewIndex: index,
        type: 'photo',
        toolbar: {delete: false},
      })
    },
  },
  filters: {
    getText: function (value) {
      if (!value) return ''
      return $('<div>' + value + '</div>').text()
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.option-collapse {
  // 展开
  &.open {
    transform: rotate(-180deg);
    transition: transform 0.5s;
  }

  // 收起
  &.close {
    transform: rotate(0deg);
    transition: transform 0.5s;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionOption/ChoiceOption.vue